import React, {FC, useMemo} from 'react';
import {Form, Formik} from 'formik';
import {useTranslation} from 'react-i18next';
import {Button} from '../../../../../common/Button';
import {formatAssigneesToOptions} from '../../../../helpers';
import {AvailableAssignee} from '../../../../types';
import {reassignTaskValidationSchema} from '../../../../../../constants/validationSchemes';
import {AutocompleteField} from '../../../../../common/formik/fields';
import {FormGroup} from '@mui/material';

export type ReassignFormParams = {
  assigneeId: number | string
}

type ReassignFormProps = {
  assignees: AvailableAssignee[],
  togglePopupVisibility: () => void,
  onSubmit: (values: ReassignFormParams) => void
}

const INITIAL_VALUES = {
  assigneeId: ''
};

const ReassignForm: FC<ReassignFormProps> = ({
  assignees,
  togglePopupVisibility,
  onSubmit
}) => {
  const {t} = useTranslation(['tasks', 'common']);
  const assigneeOptions = useMemo(() => {
    return formatAssigneesToOptions(assignees);
  }, [assignees]);

  return (
    <Formik
      initialValues={INITIAL_VALUES}
      validationSchema={reassignTaskValidationSchema}
      validateOnBlur={false}
      onSubmit={onSubmit}
    >
      {({values}) => (
        <Form>
          <div className="reassign__form">
            <FormGroup className="reassign__input">
              <AutocompleteField
                name="assigneeId"
                label="Assignee"
                options={assigneeOptions}
                maxMenuHeight={140}
              />
            </FormGroup>
          </div>

          <div className="buttons">
            <Button
              label={t('common:cancel')}
              variant="outlined"
              color="secondary"
              onClick={togglePopupVisibility}
            />

            <Button
              label={t('reassign.label')}
              variant="contained"
              color="success"
              type="submit"
              disabled={!values.assigneeId}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ReassignForm;
